import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import Automation from './Index.vue';
import CreateAutomation from './CreateAutomation.vue';
import EditAutomation from './EditAutomation.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation'),
      meta: {
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
        permissions: ['administrator'],
      },
      redirect: to => {
        return { name: 'automation_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/automation/list'),
      name: 'automation_list',
      component: Automation,
      meta: {
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/automation/new'),
      name: 'automation_new',
      component: CreateAutomation,
      meta: {
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/automation/:automationId/edit'
      ),
      name: 'automation_edit',
      component: EditAutomation,
      meta: {
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
        permissions: ['administrator'],
      },
    },
  ],
};
